<div class="base_analytics_section-header">
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54"
        viewBox="0 0 54 54" fill="none">
        <rect width="54" height="54" rx="27" fill="#E6FFD7" />
        <path
            d="M40.9914 23.8476C40.9659 23.9882 40.888 24.113 40.7718 24.1934L39.0009 25.4375C38.9088 25.5021 38.8026 25.5336 38.6992 25.5336C38.5306 25.5336 38.3648 25.4533 38.2628 25.3026L34.2451 19.4408L29.8886 22.5044C29.7724 22.5862 29.6294 22.6178 29.4919 22.592C29.3531 22.5661 29.2298 22.4872 29.1505 22.3696L27.9222 20.5759L23.495 14.1142L22.2724 14.9752C22.1038 15.0928 21.8842 15.1029 21.7071 15.001C21.5301 14.8991 21.4252 14.7025 21.4394 14.4959L21.7851 9.50068C21.7964 9.33852 21.88 9.18929 22.0117 9.096C22.1435 9.00273 22.3107 8.97547 22.4651 9.02282L27.2053 10.442C27.4008 10.5008 27.5467 10.6673 27.5793 10.8725C27.6118 11.0763 27.5254 11.2815 27.3582 11.4006L26.1356 12.2616L30.2611 18.2813L34.619 15.2177C34.7352 15.1359 34.8782 15.1043 35.0157 15.1302C35.1545 15.156 35.2778 15.2349 35.3571 15.3526L36.5826 17.1434L40.9035 23.4471C40.9857 23.5619 41.0169 23.707 40.9914 23.8476ZM20.4222 36.1523H14.7184V42.3227C14.7184 42.5896 14.9337 42.8077 15.1986 42.8077L21.4037 42.8063V34.5508L20.9163 35.8093C20.837 36.0159 20.6418 36.1523 20.4222 36.1523ZM21.156 32.2433H14.0965L13 35.0759H20.061L21.156 32.2433ZM23.1479 24.1701V31.1685H28.1347V24.1701H23.1479ZM23.8095 35.076H30.869L29.7739 32.2434H22.713L23.8095 35.076ZM17.0985 31.167H22.0853V16.7269H17.0985V31.167ZM35.887 41.4069C35.887 43.3885 34.2946 45 32.3396 45C30.3831 45 28.7922 43.3871 28.7922 41.4069C28.7922 40.1814 29.4014 39.098 30.3279 38.448C30.9002 38.0477 31.593 37.8123 32.3396 37.8123C34.2947 37.8123 35.887 39.4252 35.887 41.4069ZM32.8708 40.8874V40.1355H33.8824C34.1756 40.1355 34.4136 39.8944 34.4136 39.5974C34.4136 39.3004 34.177 39.0593 33.8824 39.0593H32.8708V38.8412C32.8708 38.5441 32.6328 38.3031 32.3396 38.3031C32.0463 38.3031 31.8083 38.5427 31.8083 38.8412V39.0765C30.9243 39.1827 30.2684 39.771 30.2684 40.5029C30.2684 41.2318 30.9243 41.8201 31.8083 41.9278V42.6797H30.8195C30.5262 42.6797 30.2882 42.9208 30.2882 43.2178C30.2882 43.5148 30.5248 43.7559 30.8195 43.7559H31.8083V43.974C31.8083 44.271 32.0463 44.5121 32.3396 44.5121C32.6328 44.5121 32.8708 44.271 32.8708 43.974V43.7387C33.7563 43.631 34.4122 43.0427 34.4122 42.3123C34.4122 41.5805 33.7549 40.9936 32.8708 40.8874ZM31.6482 36.1519H30.5616V37.099C31.1084 36.8665 31.7091 36.7374 32.3396 36.7374C32.9955 36.7374 33.6202 36.8766 34.1841 37.1277V27.3687H29.1958V31.1685H30.1365C30.3547 31.1685 30.5516 31.3048 30.631 31.51L32.1426 35.419C32.2078 35.584 32.1851 35.772 32.0874 35.9184C31.9882 36.0633 31.8239 36.1523 31.6482 36.1523L31.6482 36.1519ZM35.2467 37.7863C35.5824 38.0618 35.8771 38.3847 36.125 38.7463H40.2334V30.7091L35.2466 30.7076L35.2467 37.7863ZM29.499 37.7304V36.1505L23.4466 36.1519C23.2284 36.1519 23.0315 36.017 22.9522 35.8104L22.4648 34.5519V42.8074H27.9391C27.8016 42.3654 27.728 41.8947 27.728 41.4083C27.7294 39.9159 28.4223 38.5857 29.499 37.7304ZM31.3294 40.5027C31.3294 40.6003 31.5093 40.7639 31.8082 40.8356V40.1684C31.5093 40.2387 31.3294 40.4051 31.3294 40.5027ZM32.8707 42.6451C33.1697 42.5748 33.351 42.4083 33.351 42.3107C33.351 42.2132 33.1711 42.0481 32.8707 41.9778V42.6451Z"
            fill="#18F121" />
    </svg>
    <span i18n="@@storefront_analytics.most_popular_products">Most popular products</span>
</div>
<div class="base_analytics_section-body">
    <!-- Purchases Section -->
    <div class="d-flex flex-column w-100">
        <h4 class="mb-3" i18n="@@storefront_analytics.by_purchases">By purchases</h4>
        <div *ngFor="let item of purchasesData" class="analytics_card">
            <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <span class="name">{{ item.name }}</span>
                    <!-- <span class="price">{{ item.price }}</span> -->
                    <div>
                        <span [innerHtml]="item?.currency_symbol"></span>
                        <span class="price">  {{item.amount}}</span>
                    </div>
                </div>
                <span class="counter">{{ item.sold }}</span>
                <!-- <div class="d-flex align-items-center gap-2">
                    <div class="counter_persent"
                        [ngStyle]="{ color: item.iconColor }">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none">
                            <path
                                d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7 2.04169V11.8592"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        {{ item.percent }}
                    </div>
                    <span class="period">{{ item.period }}</span>
                </div> -->
            </div>
        </div>
    </div>

    <!-- Clicks Section -->
    <div class="d-flex flex-column w-100">
        <h4 class="mb-3" i18n="@@storefront_analytics.by_clicks">By clicks</h4>
        <div *ngFor="let item of clicksData" class="analytics_card">
            <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
            <div class="d-flex flex-column w-100 gap-2">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <span class="name">{{ item.name }}</span>
                    <!-- <span class="price">{{ item.price }}</span> -->
                    <div>
                        <span [innerHtml]="item?.currency_symbol"></span>
                        <span class="price">  {{item.amount}}</span>
                    </div>
                </div>
                <span class="counter">{{ item.clicks }}</span>
                <!-- <div class="d-flex align-items-center gap-2">
                    <div class="counter_persent"
                        [ngStyle]="{ color: item.iconColor }">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none">
                            <path
                                d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7 2.04169V11.8592"
                                stroke="item.iconColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        {{ item.percent }}
                    </div>
                    <span class="period">{{ item.period }}</span>
                </div> -->
            </div>
        </div>
    </div>
</div>
